<template>
  <div
    class="wizard-action bg-white w-full flex sm:fixed sm:bottom-0 sm:left-0 sm:z-50 mt-8 sm:py-4 sm:px-6 sm:border sm:border-black-light"
  >
    <button
      type="button"
      @click="onContinue"
      :disabled="disabledContinue"
      class="sm:flex-1 sm:order-2 btn btn-primary font-medium input-tall lg:mr-4 md:mr-4 wizard-action__continue"
    >
      Continue
    </button>

    <button
      v-if="onSkip"
      type="button"
      @click="onSkip"
      class="sm:flex-1 btn btn-outlined btn-secondary font-medium input-tall sm:mr-4"
    >
      Skip
    </button>
  </div>
</template>

<script>
export default {
  name: "WizardAction",

  props: {
    onContinue: { type: Function, default: () => {} },
    onSkip: { type: Function, required: false },
    disabledContinue: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss" scoped>
.wizard-action {
  &__continue[disabled] {
    background-color: #eb7d00;
    opacity: 0.5;
    color: #fff;
  }
}
</style>
